<template>
    <div>
        <el-form-item label="Pokaż pasek filtrowania">
            <el-switch v-model="form.show_filter_bar"/>
        </el-form-item>
        <div class="sections">
            <el-collapse class="formset__list">
                <div v-for="section, i in form.sections" class="formset__item">
                    <el-collapse-item :name="i">
                        <template slot="title">
                            <formset-header :label="section.title_pl || 'Nowa sekcja'"
                                            :items.sync="form.sections"
                                            :errors="checkForErrors(errors.sections, [i])"
                                            :index="i"/>
                        </template>
                        <div class="inline-form-group">
                            <el-form-item label="Tytuł"
                                          :error="errors.sections && errors.sections[i] && errors.sections[i][addLanguageSuffix('title')]">
                                <el-input v-model="section[addLanguageSuffix('title')]">
                                </el-input>
                            </el-form-item>
                        </div>
                        <el-form-item label="Kolor tła"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['bg_color']">
                            <el-color-picker v-model="section.bg_color"></el-color-picker>
                        </el-form-item>
                        <el-form-item label="Kolor tekstu"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['text_color']">
                            <el-color-picker v-model="section.text_color"></el-color-picker>
                        </el-form-item>
                        <el-form-item label="Typ kafla"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['tile_type']">
                            <el-radio v-for="type in availableTileTypes"
                                      :key="type.value"
                                      v-model="section.tile_type" :label="type.value"
                                      border size="medium">
                                <img class="tile" :src="type.imgSrc" :alt="type.label">
                            </el-radio>
                        </el-form-item>
                        <el-form-item label="Tagi"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['tags']">
                            <el-select v-model="section.tags"
                                       multiple
                                       placeholder="Wybierz tagi">
                                <el-option v-for="option in tags"
                                           :key="option.id"
                                           :label="option.name"
                                           :value="option.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-collapse-item>
                </div>
            </el-collapse>
            <el-button @click="addSection">+ sekcja</el-button>
        </div>
    </div>
</template>
<script>
    import {OtherEvent} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                availableTileTypes: [
                    {imgSrc: '/static/tiles/huge_logotype.png', label: "Duże logo", value: "big_logo"},
                    {imgSrc: '/static/tiles/small_logotype.png', label: "Małe logo w rogu", value: "small_logo"},
                    {imgSrc: '/static/tiles/no_logotype.png', label: "Brak loga", value: "no_logo"},
                ],
                tags: []
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                OtherEvent.tags().then(response => {
                    this.tags = response.data
                })
            },
            addSection () {
                const blankObject = {}
                if (!Array.isArray(this.form.sections)) {
                    this.$emit('update:form', {
                        ...this.form,
                        sections: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.sections.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-radio--medium.is-bordered {
        height: auto;
    }

    .tile {
        max-width: 140px;
    }
</style>


// WEBPACK FOOTER //
// EventsListWidget.vue?c4a20f70